// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const DragonflySpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'dragonfly-idle',
    metadata: {
      frames: {
        'dragonfly-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-idle-8': {
          frame: {
            x: 640,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/idle.png',
        size: {
          w: 720,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-idle': [
          'dragonfly-idle-0',
          'dragonfly-idle-1',
          'dragonfly-idle-2',
          'dragonfly-idle-3',
          'dragonfly-idle-4',
          'dragonfly-idle-5',
          'dragonfly-idle-6',
          'dragonfly-idle-7',
          'dragonfly-idle-8',
        ],
      },
    },
  },
  {
    name: 'dragonfly-hitTest',
    metadata: {
      frames: {
        'dragonfly-hitTest-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-hitTest-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-hitTest-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/hitTest.png',
        size: {
          w: 240,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-hitTest': [
          'dragonfly-hitTest-0',
          'dragonfly-hitTest-1',
          'dragonfly-hitTest-2',
        ],
      },
    },
  },
  {
    name: 'dragonfly-attack1',
    metadata: {
      frames: {
        'dragonfly-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack1-8': {
          frame: {
            x: 640,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/attack1.png',
        size: {
          w: 720,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-attack1': [
          'dragonfly-attack1-0',
          'dragonfly-attack1-1',
          'dragonfly-attack1-2',
          'dragonfly-attack1-3',
          'dragonfly-attack1-4',
          'dragonfly-attack1-5',
          'dragonfly-attack1-6',
          'dragonfly-attack1-7',
          'dragonfly-attack1-8',
        ],
      },
    },
  },
  {
    name: 'dragonfly-attack2',
    metadata: {
      frames: {
        'dragonfly-attack2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-attack2-8': {
          frame: {
            x: 640,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/attack2.png',
        size: {
          w: 720,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-attack2': [
          'dragonfly-attack2-0',
          'dragonfly-attack2-1',
          'dragonfly-attack2-2',
          'dragonfly-attack2-3',
          'dragonfly-attack2-4',
          'dragonfly-attack2-5',
          'dragonfly-attack2-6',
          'dragonfly-attack2-7',
          'dragonfly-attack2-8',
        ],
      },
    },
  },
  {
    name: 'dragonfly-hit',
    metadata: {
      frames: {
        'dragonfly-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-hit-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-hit-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/hit.png',
        size: {
          w: 240,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-hit': [
          'dragonfly-hit-0',
          'dragonfly-hit-1',
          'dragonfly-hit-2',
        ],
      },
    },
  },
  {
    name: 'dragonfly-dead',
    metadata: {
      frames: {
        'dragonfly-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
        'dragonfly-dead-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 64,
          },
          sourceSize: {
            w: 80,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragonfly/dead.png',
        size: {
          w: 560,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'dragonfly-dead': [
          'dragonfly-dead-0',
          'dragonfly-dead-1',
          'dragonfly-dead-2',
          'dragonfly-dead-3',
          'dragonfly-dead-4',
          'dragonfly-dead-5',
          'dragonfly-dead-6',
        ],
      },
    },
  },
];
